import { cn } from "utils";
import classNames from "classnames";

export const ShimmerEffect = ({ className }) => (
  <div className={cn("animate-pulse bg-gray-200 rounded-lg", className)} />
);

export const Shimmer = ({ className }) => (
  <div
    className={classNames("animate-pulse bg-gray-200 rounded-lg", className)}
  />
);
